import { useNavigate } from 'react-router-dom';
import './Website.css';

const Websites = () => {
    const navigation = useNavigate();

  return (
    <div style={{marginBottom: '50px'}}>
        <div className='panel-main'>
            <div style={{display: 'flex', flexWrap: 'wrap'}}>
                <div className='left-side-o'>
                    <h1 className='heading-proj'>Initative Tracker</h1>
                    <p className='tab-p'>A webapp that helps keep track of initiative in role playing games. 
                        It allows players to connect to a session to view the current turn order in the game, and whose turn it currently is in the game. 
                        The gamemaster can also keep track of enemy hit points and other useful information that is not shown to other players. </p>
                    <br />
                    <p className='tab-p'>It was built with an Angular frontend, and an Express JS server backend. The backend is used for connecting players to sessions created by the gamemaster. 
                        The app makes use of web sockets for near instant communication between clients.</p>
                    <br />
                    <p className='tab-tech'><span className='primary-f'>Technologies used:</span> <span className='secondary-f'> Angular, ExpressJS</span></p>
                    <button className='page-button primary margin-home' onClick={() => window.open('https://github.com/KungusKong/TrackerApp/')}>App Github</button>
                    <button className='page-button secondary margin-home' style={{fontSize: '22px'}} onClick={() => window.open('https://github.com/KungusKong/TrackerServer')}>Server Github</button>
                </div>
                <div className='right-side-o'>
                    <img src="./Imgs/TrackerImage.PNG" className='tracker-img' alt="TrackerImage" />
                </div>
            </div>
        </div>
        <div className='panel-secondary'>
            <div style={{display: 'flex', flexWrap: 'wrap'}}>
                <div className='left-side-e'>
                    <img src="./Imgs/Capstone Pic.PNG" style={{width: '600px'}} className='tracker-img' alt="TrackerImage" />
                </div>
                <div className='right-side-e' >
                    <h1 className='heading-proj'>NDSU Capstone Project</h1>
                    
                    <p className='tab-p'>For my capstone project at NDSU, my team was assigned to Scheels to build an app that would allow them to keep track of employees who were absent or late on any given day. 
                    Currently, they use a piece of paper to see who is supposed to be in and when. If someone is absent or late, they must ask around to find out about them. 
                    This app gives them a way to quickly check and see who is absent that day. </p>
                    <br />
                    <p className='tab-p'>Our team worked with Scheels to build them the app using React Js for the frontend and .Net Core with Postgresql for the backend. 
                    Our team worked together to create the database, API, and React app over the course of the semester, meeting with Scheels weekly along the way.</p>
                    <br />
                    <p className='tab-tech'><span className='primary-f'>Technologies used:</span> <span className='secondary-f'> React, .Net Core, Postresql</span></p>
                </div>
            </div>
        </div>
        <div className='panel-main'>
            <div style={{display: 'flex', flexWrap: 'wrap'}}>
                <div className='left-side-o' >
                    <h1 className='heading-proj'>Bug/Issue Tracker</h1>
                    <p className='inProgress'>-- In Progress</p>
                    <p className='tab-p'>The Bug/Issue tracker is a project that I am currently working on to fill a personal need for better organization of my own personal projects. 
                    At my internship and again working with Scheels for the capstone project, I have grown accustomed to the use of issue trackers such as Azure Devops and Jira,
                     and I decided to create my own issue tracker for 2 main reasons: 
                    To increase my knowledge of React and .Net Core, and to own a free alternative to other issue tracking software.  </p>
                    <br />
                    <p className='tab-p'>Currently, I have completed around 85% of the API/Backend and am currently working on the main structure for the frontend of the web app, 
                    with a goal of full functionality of the app completed by the first week of May. 
                    Along the way, I am planning the project using the current backend and the SwaggerUI for .Net Core. </p>
                    <br />
                    <p className='tab-tech'><span className='primary-f'>Technologies used:</span> <span className='secondary-f'> React, .Net Core, Postresql</span></p>
                </div>
                <div className='right-side-o'>
                    <img src="./Imgs/BugTracker.PNG" style={{width: '670px'}} className='tracker-img' alt="TrackerImage" />
                </div>
            </div>
        </div>
        <div className='panel-secondary'>
            <div style={{display: 'flex', flexWrap: 'wrap'}}>
                <div className='left-side-e'>
                    <img src="./SiteLogo.png" className='tracker-img' style={{width: '600px'}} alt="TrackerImage" />
                </div>
                <div className='right-side-e' >
                    <h1 className='heading-proj'>Portfolio Site</h1>
                    <p className='tab-p' style={{marginBottom: '20px'}}>I built the site you are currently on using my own Css classes and React for easy reusability. If you like what you see, consider taking a look at my resume or
                    contacting me using the information below. I'd love to hear from you! </p>
                    <hr />
                    <ul className='info'>
                        <li className='info-item'>Email: <span className='primary-f'>thdawson1999@gmail.com</span></li>
                        <li className='info-item'>Call or Text: <span className='secondary-f'>(701) 630-0703</span></li>
                    </ul>
                    <button className='page-button secondary margin-home'onClick={() => navigation('/resume')}>Resume</button>
                    <button className='page-button primary margin-home' onClick={() => window.open('https://github.com/KungusKong/')}>Github</button>
                </div>
            </div>
        </div>
    </div>
  )
}

export default Websites